import CloseIcon from '@mui/icons-material/Close';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import React, { PropsWithoutRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { SIDEBAR_WIDTH } from '../constants';

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({ mobileOpen, handleSidebarToggle }: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(true);
  const [open1, setOpen1] = React.useState(true);
  const [open3, setOpen3] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  const handleClick1 = () => {
    setOpen1(!open1);
  };

  const handleClick3 = () => {
    setOpen3(!open3);
  };

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: 'relative' }}>
        <figure>
          <img src="/static/images/authLogo.png" alt="" onClick={() => navigate('/dashboard')} />
        </figure>

        <IconButton
          sx={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            color: 'white',
            display: { lg: 'none' },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        {/* Dashboard */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/dashboard'}
          onClick={() => navigate('/dashboard')}
        >
          <ListItemIcon>
            <img src="/static/images/dashboard.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Dashboard" />
        </ListItemButton>

        {/* Registrations */}
        <ListItemButton
          className="lst-itm"
          onClick={handleClick}
          selected={
            location.pathname === '/registrations/individual' ||
            location.pathname === '/registrations/dealers' ||
            location.pathname === '/registrations/stores'
            /*add new path here*/
          }
        >
          <ListItemIcon>
            <img src="/static/images/registrations.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Registrations" />
          {open ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
        </ListItemButton>
        <Collapse
          in={
            !open ||
            location.pathname === '/registrations/individual' ||
            location.pathname === '/registrations/dealers' ||
            location.pathname === '/registrations/stores'
            /*add new path here*/
          }
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            <ListItemButton
              selected={location.pathname === '/registrations/individual'}
              onClick={() => navigate('/registrations/individual')}
            >
              <ListItemText primary="Individuals" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === '/registrations/dealers'}
              onClick={() => navigate('/registrations/dealers')}
            >
              <ListItemText primary="Dealers" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === '/manage-store'}
              onClick={() => navigate('/manage-store')}
            >
              <ListItemText primary="Stores" />
            </ListItemButton>
            {/* <ListItemButton
              selected={location.pathname === "/registrations/stores"}
              onClick={() => navigate("/registrations/stores")}
            >
              <ListItemText primary="Stores" />
            </ListItemButton> */}
          </List>
        </Collapse>

        {/* Listings */}
        <ListItemButton
          className="lst-itm"
          onClick={handleClick1}
          selected={
            location.pathname === '/listings/individual' ||
            location.pathname === '/listings/dealers' ||
            location.pathname === '/listings/stores' ||
            location.pathname === '/listings/myList'
          }
        >
          <ListItemIcon>
            <img src="/static/images/list.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Listings" />
          {open1 ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
        </ListItemButton>
        <Collapse
          in={
            !open1 ||
            location.pathname === '/listings/individual' ||
            location.pathname === '/listings/dealers' ||
            location.pathname === '/listings/stores' ||
            location.pathname === '/listings/myList'
          }
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {/* <ListItemButton
              selected={location.pathname === "/listings/myList"}
              onClick={() => navigate("/listings/myList")}
            >
              <ListItemText primary="My Listings" />
            </ListItemButton> */}
            <ListItemButton
              selected={location.pathname === '/listings/individual'}
              onClick={() => navigate('/listings/individual')}
            >
              <ListItemText primary="Individual Listings" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === '/listings/dealers'}
              onClick={() => navigate('/listings/dealers')}
            >
              <ListItemText primary="Dealer Listings" />
            </ListItemButton>
            {/* <ListItemButton
              selected={location.pathname === "/listings/stores"}
              onClick={() => navigate("/listings/stores")}
            >
              <ListItemText primary="Store Listings" />
            </ListItemButton> */}
          </List>
        </Collapse>
        {/* Vehicle Types */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-vehicle-types'}
          onClick={() => navigate('/manage-vehicle-types')}
        >
          <ListItemIcon>
            <img src="/static/images/vehicleType.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Vehicle Types" />
        </ListItemButton>

        {/* Vehicle Features */}
        <ListItemButton
          className="lst-itm"
          onClick={handleClick3}
          selected={
            location.pathname === '/vehicle-specifications/brands' ||
            location.pathname === '/vehicle-specifications/brands-trim' ||
            location.pathname === '/vehicle-specifications/features' ||
            location.pathname === '/vehicle-specifications/technical-features' ||
            location.pathname === '/vehicle-specifications/regional-specifications' ||
            location.pathname === '/vehicle-specifications/equipments' ||
            location.pathname === '/vehicle-specifications/model' ||
            location.pathname === '/vehicle-specifications/model-trim' ||
            location.pathname === '/vehicle-specifications/drive-type' ||
            location.pathname === '/vehicle-specifications/power' ||
            location.pathname === '/vehicle-specifications/gcc' ||
            location.pathname === '/vehicle-specifications/colors' ||
            location.pathname === '/vehicle-specifications/body-type' ||
            location.pathname === '/vehicle-specifications/damage-type' ||
            location.pathname === '/vehicle-specifications/fuel-type' ||
            location.pathname === '/vehicle-specifications/engine-capacity' ||
            location.pathname === '/vehicle-specifications/financial-year' ||
            location.pathname === '/vehicle-specifications/loan-interest-rates'
          }
        >
          <ListItemIcon>
            <img src="/static/images/specification.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Vehicle Specifications" />
          {open3 ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
        </ListItemButton>
        <Collapse
          in={
            !open3 ||
            location.pathname === '/vehicle-specifications/brands' ||
            location.pathname === '/vehicle-specifications/brands-trim' ||
            location.pathname === '/vehicle-specifications/features' ||
            location.pathname === '/vehicle-specifications/technical-features' ||
            location.pathname === '/vehicle-specifications/regional-specifications' ||
            location.pathname === '/vehicle-specifications/equipments' ||
            location.pathname === '/vehicle-specifications/model' ||
            location.pathname === '/vehicle-specifications/model-trim' ||
            location.pathname === '/vehicle-specifications/drive-type' ||
            location.pathname === '/vehicle-specifications/power' ||
            location.pathname === '/vehicle-specifications/gcc' ||
            location.pathname === '/vehicle-specifications/colors' ||
            location.pathname === '/vehicle-specifications/body-type' ||
            location.pathname === '/vehicle-specifications/damage-type' ||
            location.pathname === '/vehicle-specifications/fuel-type' ||
            location.pathname === '/vehicle-specifications/engine-capacity' ||
            location.pathname === '/vehicle-specifications/financial-year' ||
            location.pathname === '/vehicle-specifications/loan-interest-rates'
          }
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {/* Brands */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/brands'}
              onClick={() => navigate('/vehicle-specifications/brands')}
            >
              <ListItemText primary="Brands" />
            </ListItemButton>
            {/* Brands trim */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/brands-trim'}
              onClick={() => navigate('/vehicle-specifications/brands-trim')}
            >
              <ListItemText primary="Brands Name Trim" />
            </ListItemButton>
            {/* Features */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/features'}
              onClick={() => navigate('/vehicle-specifications/features')}
            >
              <ListItemText primary="Features" />
            </ListItemButton>
            {/* Equipments */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/equipments'}
              onClick={() => navigate('/vehicle-specifications/equipments')}
            >
              <ListItemText primary="Equipments" />
            </ListItemButton>
            {/* Drive Type */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/drive-type'}
              onClick={() => navigate('/vehicle-specifications/drive-type')}
            >
              <ListItemText primary="Drive Type" />
            </ListItemButton>
            {/* Colors */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/colors'}
              onClick={() => navigate('/vehicle-specifications/colors')}
            >
              <ListItemText primary="Colors" />
            </ListItemButton>

            {/* Body Type */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/body-type'}
              onClick={() => navigate('/vehicle-specifications/body-type')}
            >
              <ListItemText primary="Body Type" />
            </ListItemButton>
            {/* Technical Features */}
            {/* <ListItemButton
              selected={
                location.pathname ===
                "/vehicle-specifications/technical-features"
              }
              onClick={() =>
                navigate("/vehicle-specifications/technical-features")
              }
            >
              <ListItemText primary="Technical Features" />
            </ListItemButton> */}
            {/* Regional Spec */}
            {/* <ListItemButton
              selected={
                location.pathname ===
                "/vehicle-specifications/regional-specifications"
              }
              onClick={() =>
                navigate("/vehicle-specifications/regional-specifications")
              }
            >
              <ListItemText primary="Regional Specifications" />
            </ListItemButton> */}
            {/* GCC */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/gcc'}
              onClick={() => navigate('/vehicle-specifications/gcc')}
            >
              <ListItemText primary="GCC" />
            </ListItemButton>
            {/* Model */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/model'}
              onClick={() => navigate('/vehicle-specifications/model')}
            >
              <ListItemText primary="Model" />
            </ListItemButton>
            {/* Model Trim */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/model-trim'}
              onClick={() => navigate('/vehicle-specifications/model-trim')}
            >
              <ListItemText primary="Model Name Trim" />
            </ListItemButton>

            {/* Power */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/power'}
              onClick={() => navigate('/vehicle-specifications/power')}
            >
              <ListItemText primary="Power" />
            </ListItemButton>

            {/* Damage */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/damage-type'}
              onClick={() => navigate('/vehicle-specifications/damage-type')}
            >
              <ListItemText primary="Damage Type" />
            </ListItemButton>

            {/* Fuel Type */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/fuel-type'}
              onClick={() => navigate('/vehicle-specifications/fuel-type')}
            >
              <ListItemText primary="Fuel Type" />
            </ListItemButton>

            {/* Engine Capacity */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/engine-capacity'}
              onClick={() => navigate('/vehicle-specifications/engine-capacity')}
            >
              <ListItemText primary="Engine Capacity" />
            </ListItemButton>

            {/* financial year */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/financial-year'}
              onClick={() => navigate('/vehicle-specifications/financial-year')}
            >
              <ListItemText primary="Financial Years" />
            </ListItemButton>

            {/* loan interest rate */}
            <ListItemButton
              selected={location.pathname === '/vehicle-specifications/loan-interest-rates'}
              onClick={() => navigate('/vehicle-specifications/loan-interest-rates')}
            >
              <ListItemText primary="Loan Interest Rates" />
            </ListItemButton>
          </List>
        </Collapse>

        {/* -------------------------------------------- */}
        {/* Blogs */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/blogs'}
          onClick={() => navigate('/blogs')}
        >
          <ListItemIcon>
            <img src="/static/images/blog.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Blogs" />
        </ListItemButton>

        {/* Inspection Requests */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/inspection-requests'}
          onClick={() => navigate('/inspection-requests')}
        >
          <ListItemIcon>
            <img src="/static/images/vehicle-inspection.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Inspection Requests" />
        </ListItemButton>

        {/* Financial Requests */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/financial-requests'}
          onClick={() => navigate('/financial-requests')}
        >
          <ListItemIcon>
            <img src="/static/images/financial-statement.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Financial Requests" />
        </ListItemButton>

        {/* Packages */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-packages'}
          onClick={() => navigate('/manage-packages')}
        >
          <ListItemIcon>
            <img src="/static/images/subscription.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Packages" />
        </ListItemButton>

        {/* Promo Codes */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-promo-codes'}
          onClick={() => navigate('/manage-promo-codes')}
        >
          <ListItemIcon>
            <img src="/static/images/coupons.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Promo Codes" />
        </ListItemButton>

        {/* Promotional Campaigns */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/promotional-campaigns'}
          onClick={() => navigate('/promotional-campaigns')}
        >
          <ListItemIcon>
            <img src="/static/images/email-marketing.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Promotional Campaigns" />
        </ListItemButton>

        {/* Ratings and Reviews */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/ratings-and-reviews'}
          onClick={() => navigate('/ratings-and-reviews')}
        >
          <ListItemIcon>
            <img src="/static/images/review.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Ratings and Reviews" />
        </ListItemButton>
        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/customer-support"}
          onClick={() => navigate("/customer-support")}
        >
          <ListItemIcon>
            <img src="/static/images/customer-support.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Customer Support" />
        </ListItemButton> */}

        {/*
        
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/report-an-issue"}
          onClick={() => navigate("/report-an-issue")}
        >
          <ListItemIcon>
            <img src="/static/images/status_icon.svg" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Report an Issues" />
        </ListItemButton>

     

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/reports"}
          onClick={() => navigate("/reports")}
        >
          <ListItemIcon>
            <img src="/static/images/status_icon.svg" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Reports" />
        </ListItemButton>

       */}

        {/* Subadmin */}
        <ListItemButton
          className="lst-itm"
          onClick={handleClick3}
          selected={
            location.pathname === '/user-management/roles' ||
            location.pathname === '/user-management/user-list'
          }
        >
          <ListItemIcon>
            <img src="/static/images/admin-panel.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Sub-admin" />
          {open3 ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
        </ListItemButton>
        <Collapse
          in={
            !open3 ||
            location.pathname === '/user-management/roles' ||
            location.pathname === '/user-management/user-list'
          }
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            <ListItemButton
              selected={location.pathname === '/user-management/roles'}
              onClick={() => navigate('/user-management/roles')}
            >
              <ListItemText primary="Roles" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === '/user-management/user-list'}
              onClick={() => navigate('/user-management/user-list')}
            >
              <ListItemText primary="Subadmin List" />
            </ListItemButton>
          </List>
        </Collapse>

        {/* Notifications */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-notifications'}
          onClick={() => navigate('/manage-notifications')}
        >
          <ListItemIcon>
            <img src="/static/images/notification_icon.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Notifications" />
        </ListItemButton>

        {/* NEWSLETTER EMAIL */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-newsletter-users'}
          onClick={() => navigate('/manage-newsletter-users')}
        >
          <ListItemIcon>
            <ContactMailIcon style={{ color: 'white' }} />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Newsletter User" />
        </ListItemButton>
        {/* CMS */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-cms'}
          onClick={() => navigate('/manage-cms')}
        >
          <ListItemIcon>
            <img src="/static/images/cms.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage CMS" />
        </ListItemButton>

        {/* Payment */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-payment'}
          onClick={() => navigate('/manage-payment')}
        >
          <ListItemIcon>
            <img src="/static/images/payIcon.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Payment" />
        </ListItemButton>

        {/* Analytics */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-analytics'}
          onClick={() => navigate('/manage-analytics')}
        >
          <ListItemIcon>
            <img src="/static/images/analytics.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Analytics" />
        </ListItemButton>
        {/* Customer Support */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === '/manage-CustomerSupport'}
          onClick={() => navigate('/manage-CustomerSupport')}
        >
          <ListItemIcon>
            <img src="/static/images/registrations.png" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Customer Support" />
        </ListItemButton>
      </List>
    </>
  );

  return (
    <Box component="nav" sx={{ flexShrink: { lg: 0 } }} className="sidebar-main-div">
      <Drawer
        className="sidebar_drawer sidebar-main-div"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', lg: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: 'none', lg: 'block' },
          '& .MuiDrawer-paper': {
            width: SIDEBAR_WIDTH,
            boxSizing: 'border-box',
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
